import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import M from 'materialize-css';
import { compose } from 'redux';
import { firestoreConnect } from 'react-redux-firebase';

const defaultClaimMessageXP = 'Your bonus XP has been added!';
const defaultClaimMessageEntries = 'Your entries have been added!';
const defaultTemplateXP = '{0} Bonus XP';
const defaultTemplateEntries = '{0} Entries to the "Level Up" Contest';
const defaultTemplateGiftcard = `$${0} Gift Card`;
const defaultRewardsScratch = {
  xp: { template: defaultTemplateXP },
  entries: { template: defaultTemplateEntries },
  giftcard: { template: defaultTemplateGiftcard },
};
const refModalImages = React.createRef();

function NewLevel(props) {
  const [levelName, setLevelName] = useState(1);
  const [minimalXp, setMinimalXp] = useState(0);
  const [minXp, setMinXp] = useState(0);
  const [maxXp, setMaxXp] = useState(0);
  const [levelSaved, setLevelSaved] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [levelsAux, setLevelsAux] = useState([]);
  const [rewardsXP, setRewardsXP] = useState({ claimMessage: defaultClaimMessageXP });
  const [rewardsEntries, setRewardsEntries] = useState({ claimMessage: defaultClaimMessageEntries });
  const [rewardsScratch, setRewardsScratch] = useState(defaultRewardsScratch);
  const [imageField, setImageField] = useState('');
  const [contests, setContests] = useState({});
  const { firestore, levels, images, levelId, levelUpContests } = props;

  useEffect(() => {
    M.AutoInit();
    M.updateTextFields();
    let elements = document.querySelectorAll('.modal');
    M.Modal.init(elements);
  }, []);

  useEffect(() => {
    if (!levelUpContests) return;
    const contestsObj = {};
    Object.keys(levelUpContests).forEach((key) => {
      contestsObj[levelUpContests[key]['countryCode']] = { contestId: key };
    });
    setContests(contestsObj);
  }, [levelUpContests]);

  const getMinimalXp = () => {
    let minimalXp = 0;
    levels.forEach((level) => {
      if (minimalXp < level.maxXp) {
        minimalXp = level.maxXp;
      }
    });
    return minimalXp;
  };

  if (levels && levels.length && !loading) {
    const nextLevel = levels.length + 1;
    const minimalXp = getMinimalXp() + 1;
    setMinXp(minimalXp);
    setMaxXp(minimalXp + 1);
    setMinimalXp(minimalXp);
    setLevelName(nextLevel);
    setLevelsAux(levels);
    setLoading(true);
  }

  useEffect(() => {
    if (!levelId || levelsAux.length === 0) return;
    const level = levelsAux.find((i) => i.id === levelId);
    setLevelName(level.levelName);
    setMinXp(level.minXp);
    setMaxXp(level.maxXp);
    setContests(level.contests || []);
    setRewardsEntries(level.rewardsEntries || { claimMessage: defaultClaimMessageEntries });
    setRewardsScratch(level.rewardsScratch || defaultRewardsScratch);
    setRewardsXP(level.rewardsXP || { claimMessage: defaultClaimMessageXP });
  }, [levelId, levelsAux]);

  const changeMinXp = (minXp) => {
    if (minXp >= minimalXp && minXp >= 0) setMinXp(minXp);
  };

  const changeMaxXp = (maxXp) => {
    if (maxXp > 0) {
      setMaxXp(maxXp);
    }
  };

  const changeLevelName = (name) => {
    if (name > 0) {
      setLevelName(name);
    }
  };

  const validLevelName = () => {
    let existLevel = false;
    if (levelsAux && levelsAux.length > 0) {
      levelsAux.forEach((level) => {
        if (levelName === level.levelName) {
          setMessageError('there is a level with this name');
          setShowError(true);
          existLevel = true;
        }
      });
    }
    return existLevel;
  };

  const saveLevel = (e) => {
    e.preventDefault();
    if (!levelId && validLevelName()) {
      return;
    }
    if (maxXp > minXp) {
      const docId = `LEVEL_${levelName}`;

      const newLevel = {
        id: docId,
        updatedAt: firestore.FieldValue.serverTimestamp(),
        levelName: levelName,
        minXp: minXp,
        maxXp: maxXp,
        contests,
        rewardsEntries,
        rewardsScratch,
        rewardsXP,
      };

      firestore
        .collection('levels')
        .doc(docId)
        .set(newLevel)
        .then(() => {
          setLevelSaved(true);
        })
        .catch((e) => console.error(e));
    } else {
      setMessageError('maxLevel must be higher than minLevel');
      setShowError(true);
    }
  };

  const openImageDialog = (onChoose) => {
    setImageField({ onChoose });
    M.Modal.getInstance(refModalImages.current).open();
  };

  const closeImagesModal = () => {
    const modal = document.getElementById('modalImages');
    M.Modal.getInstance(modal).close();
  };

  const renderImagesDialog = () => {
    return (
      <div ref={refModalImages} id="modalImages" className="modal">
        <div className="modal-content">{renderImages()}</div>
      </div>
    );
  };

  const renderImages = () =>
    !images ? null : (
      <div>
        <h5>Select an image:</h5>
        <div className="row">{Object.keys(images).map((imageId) => image(imageId, images))}</div>
      </div>
    );

  const image = (imageId, images) => (
    <div
      key={imageId}
      className="col s2"
      onClick={() => {
        imageField.onChoose(images[imageId].url);
        closeImagesModal();
      }}>
      <img src={images[imageId].url} width="100" height="100" alt="" />
      <br />
    </div>
  );

  const renderRewards = () => (
    <div>
      <h4>Rewards</h4>
      {renderRewardsSection('XP', rewardsXP, setRewardsXP, `Bonus X XP`)}
      {renderRewardsSection('Contest entries', rewardsEntries, setRewardsEntries, `X "Level Up" Contest Entries`)}
      {renderRewardsSection('Scratch', rewardsScratch, setRewardsScratch, `X "Level Up to Win" Chances`, false)}
      <div className="row">
        {scratchItem('XP', 'xp')}
        {scratchItem('Contest entries', 'entries')}
        {scratchItem('Giftcard', 'giftcard')}
      </div>
    </div>
  );

  const renderRewardsSection = (title, section, setData, placeholder, claimMessage = true) => (
    <div>
      <h5>{title}</h5>
      <div className="row">
        {numberInput('Quantity', section.quantity, 4, (e) => setData({ ...section, quantity: parseInt(e.target.value) }))}
        {textInput('Label', section.label, 4, placeholder, (e) => setData({ ...section, label: e.target.value }))}
        {claimMessage && textInput('Claim message', section.claimMessage, 4, placeholder, (e) => setData({ ...section, claimMessage: e.target.value }))}
      </div>
      <div className="row">
        {section.icon ? <img className="col s1" src={section.icon} alt="" /> : null}
        {textInput('Icon url', section.icon, section.icon ? 11 : 12, '', false, () => openImageDialog((e) => setData({ ...section, icon: e })))}
      </div>
      <div className="row">
        {section.iconDisabled ? <img className="col s1" src={section.iconDisabled} alt="" /> : null}
        {textInput('Disabled icon url', section.iconDisabled, section.iconDisabled ? 11 : 12, '', false, () => openImageDialog((e) => setData({ ...section, iconDisabled: e })))}
      </div>
    </div>
  );

  const scratchItem = (title, scratchField) => {
    if (!rewardsScratch[scratchField]) return null;
    return (
      <div className="row col s4">
        <h6 style={{ textAlign: 'center' }}>{title}</h6>
        {textInput('Template', rewardsScratch[scratchField].template, 12, '', (e) => setRewardsScratch({ ...rewardsScratch, [scratchField]: { ...rewardsScratch[scratchField], template: e.target.value } }))}
      </div>
    );
  };

  const textInput = (label, value, colSize, placeholder, setData = () => {}, onClick = () => {}) => (
    <div className={`input-field col s${colSize}`}>
      <input id={`${label}${value}`} type="text" className="validate" value={value || ''} onChange={(e) => setData(e)} placeholder={placeholder} onClick={() => onClick()} />
      <label htmlFor={`${label}${value}`} className="active">
        {label}
      </label>
    </div>
  );

  const numberInput = (label, value, colSize, setData, disabled = false) => (
    <div className={`input-field col s${colSize}`}>
      <input id={`${label}${value}`} type="number" className="validate" value={value || 0} disabled={disabled} onChange={(e) => setData(e)} />
      <label htmlFor={`${label}${value}`}>{label}</label>
    </div>
  );

  const renderErrorMessage = () => (
    <div className="card-action">
      <h6 className="red-text">{messageError}</h6>
    </div>
  );

  const { auth } = props;
  if (!auth.uid) return <Redirect to="/signin" />;
  if (levelSaved) return <Redirect to="/levels" />;

  return (
    <div className="container">
      <div className="card z-depth-2 project-summary">
        <form className="col s12 new-form">
          <div className="card-content">
            {renderImagesDialog()}
            <div className="row">
              <div className="col s12">
                <h4>{levelId ? 'Edit' : 'New'} Level</h4>
              </div>
            </div>
            <div className="row">
              {numberInput('Level', levelName, 12, (e) => changeLevelName(parseInt(e.target.value)), levelId)}
              {numberInput('Min Xp', minXp, 12, (e) => changeMinXp(parseInt(e.target.value)))}
              {numberInput('Max Xp', maxXp, 12, (e) => changeMaxXp(parseInt(e.target.value)))}
            </div>
            {renderRewards()}
          </div>
          {showError && renderErrorMessage()}
          <div className="card-action">
            <button className="waves-effect waves-light btn-small" onClick={(e) => saveLevel(e)}>
              {levelId ? 'Update' : 'Create'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state, ownProps) => {
  return {
    levelId: ownProps.match.params.id,
    levels: state.firestore.ordered.levels,
    auth: state.firebase.auth,
    images: state.firestore.data['images'],
    levelUpContests: state.firestore.data['levelUpContests'],
  };
};

export default compose(
  firestoreConnect([
    { collection: 'levels', orderBy: ['level', 'asc'] },
    { collection: 'images', where: ['tags', 'array-contains', 'levelUp'], storeAs: 'images' },
    { collection: 'contests', where: ['actions', 'array-contains', 'LEVEL_UP'], storeAs: 'levelUpContests' },
  ]),
  connect(mapStateToProps),
)(NewLevel);
